import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';


//redux
import { useDispatch, useSelector } from 'react-redux';

import { Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import { SuitabilitiesAPI } from '../../../../../API/suitabilities';
import { myLabelInput, unoTheme } from '../../../../../assets/styles/unoTheme';
import { getColorSuitability } from '../../../../../controllers/ClientController';
import UnoButton from '../../../../utils/UnoButton';
import allActions from '../../../../../actions';

const RESULTS_DESCRIPTIOS = {
    "CONSERVADOR": "Esse investidor prioriza, em alguns casos por necessidade, a estabilidade em suas aplicações e possui uma tolerância baixa ao risco. Dado o seu patrimônio relacionado às necessidades e obrigações, presentes e futuras, do seu RPPS, busca investimentos em ativos com liquidez e baixa volatilidade.",

    "MODERADO": "Esse investidor se posiciona entre os Conservadores e Agressivos. Ele preza por investimentos que proporcionem a segurança dos seus recursos e possui uma certa tolerância ao risco, buscando retornos acima da média no longo prazo. Possui um maior conhecimento de mercado e têm um patrimônio em crescimento.",

    "AGRESSIVO": "Esse investidor tem um amplo conhecimento sobre investimentos e boa tolerância ao risco. Ele lida bem com volatilidade no curto prazo em busca de maiores retornos no longo prazo. Possui um patrimônio consolidado e em crescimento podendo se expor em um grau maior a investimentos mais voláteis."
}

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',

    },

    dialogTitleApr: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            //justifyContent: 'space-between'
        }

    },

    dialogContent: {
        '& .MuiBox-root': {
            textAlign: 'center',
        },

    },

    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    warningColor: {
        color: unoTheme.warningColor
    },
    label: myLabelInput,
    afirmativeText: {
        color: 'black'
    },
    noPaddingLeft: {
        paddingLeft: '0px',
    },
    noPaddingRight: {
        paddingRight: '0px !important',
    },
    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    questionary: {
        '& .question': {
            marginBottom: '24px',
            '& .option-question span': {
                fontSize: '14px !important'
            }
        }


    }
}));

export default function SuitabilityDetailModal(props) {

    const { handleCloseModal, clientOnScreen, suitability } = props;

    const classes = useStyles();

    const dispatch = useDispatch();
    const history = useHistory();
    const currentUser = useSelector(state => state.currentUser);
    const [activeQuestionary, setActiveQuestionary] = useState();

    console.log("SUITABILITY: ", suitability);

    const resumedResponses = useMemo(() => {

        if (!activeQuestionary || !suitability?.id) return [];

        const questionary = JSON.parse(activeQuestionary.questionary)
        const responsesQuestionsArray = [];

        if (suitability.response !== "MANUAL_SUITABILITY" && suitability.response !== "CHECK_LIFETIME_SUITABILITY") {

            const responses = JSON.parse(suitability.response);
            questionary.forEach((element, index) => {

                responsesQuestionsArray.push(
                    <div className='question'>
                        <Typography variant='h6' key={'question-response-title-' + index}>{(index + 1) + ". " + element.pergunta}</Typography>
                        <Typography variant='h6' style={{ color: "blue" }} key={'question-response-' + index}>RESPOSTA: {element.opcoes[parseInt(responses[index])]}</Typography>

                    </div>
                )

            });


            return responsesQuestionsArray;
        } else {
            if (suitability.response == "MANUAL_SUITABILITY") {

                return (
                    <div style={{ color: "red" }}>Suitability alterado manualmente por um Super Admin, Admin ou Consultor</div>
                )
            } else {

                return (
                    <div style={{ color: "red" }}>Suitability alterado automaticamente pelo sistema após fim da vigência do último questionário suitability respondido</div>
                )
            }
        }
    }, [activeQuestionary, suitability])

    const loadActiveQuestionary = async () => {
        const responseActiveQuestionary = await SuitabilitiesAPI.getActiveSuitabilitieQuestionary();
        if (responseActiveQuestionary.success && responseActiveQuestionary.body.rows.length == 1) {
            setActiveQuestionary(responseActiveQuestionary.body.rows[0]);
        }
    }

    const clean = () => {
        setActiveQuestionary(null);
    }

    const doReportSuitability = () => {
        console.log("Gerar report");
        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: 'clientSuitability',
            suitabilityId: 1,
            message: 'Gerando PDF...',

        }))
    }

    useEffect(() => {
        if (suitability?.id) {
            loadActiveQuestionary();
        } else {
            setTimeout(() => {
                clean()
            }, 500)
        }
    }, [suitability])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={suitability?.id}
        >
            <DialogTitle
                className={classes.dialogTitleApr}>
                {
                    <><CheckIcon className={[classes.spacingRight2, classes.green].join(' ')} />Respostas da avaliação Suitability</>
                }


            </DialogTitle>


            {

                <DialogContent
                    id={"suitability-dialog-content"}
                    className={classes.dialogContent}>

                    <div>

                        <Typography style={{ textAlign: "justify" }}>{clientOnScreen?.rpps_name}</Typography>
                        <br />
                        <div>
                            <Typography style={{ textAlign: "justify", fontWeight: "bold" }}>Responsável: <span style={{ fontWeight: "normal" }}>{suitability?.user_name}</span></Typography>
                            <Typography style={{ textAlign: "justify", fontWeight: "bold" }}>Data da avaliação: <span style={{ fontWeight: "normal" }}>{moment.utc(suitability?.created_date).format("DD/MM/YYYY HH:mm")}</span></Typography>
                            <Typography style={{ textAlign: "justify", fontWeight: "bold" }}>Resultado: <span style={{ background: getColorSuitability(suitability?.result), padding: "2px 16px", borderRadius: "20px", color: "white" }}>{suitability?.result}</span></Typography>
                        </div>
                        <br />

                        <Typography style={{ textAlign: "justify", fontWeight: "bold" }}>Resumo das repostas</Typography>
                        <br />
                        <div className={classes.questionary}>
                            {resumedResponses}
                        </div>
                    </div>

                </DialogContent>
            }


            <DialogActions className={classes.actionsFlexRight}>
                <UnoButton
                    onClick={() => handleCloseModal()} color="secondary">
                    {'Fechar'}
                </UnoButton>
            </DialogActions>

        </Dialog >
    );
}